import React, { Component, createRef } from 'react';
import { ToolbarContext } from '../components/toolbar-context.js';
import { calculateNodeTotalWidth } from '../utils/node-util.js';
import styles from './toolbar-button.less.js';

class ToolbarButtonDivider extends Component {
    constructor() {
        super(...arguments);
        this.buttonDividerRef = createRef();
    }
    componentDidMount() {
        var _a;
        const width = calculateNodeTotalWidth(this.buttonDividerRef.current, false);
        if (this.props.id) {
            (_a = this.context.shrinkManager) === null || _a === void 0 ? void 0 : _a.updateWidth(this.props.id, width);
        }
    }
    componentWillUnmount() {
        var _a;
        if (this.props.id) {
            (_a = this.context.shrinkManager) === null || _a === void 0 ? void 0 : _a.withdraw(this.props.id);
        }
    }
    render() {
        var _a;
        const { multirows } = this.context;
        return (React.createElement("div", { ref: this.buttonDividerRef, id: (_a = this.props.id) !== null && _a !== void 0 ? _a : '', className: `${styles.divider} ${multirows ? styles.multirows : ''}` }));
    }
}
ToolbarButtonDivider.contextType = ToolbarContext;

export { ToolbarButtonDivider };
//# sourceMappingURL=toolbar-button-divider.js.map
